module.exports = __webpack_public_path__ + "store/img/ca.ad152714.svg";